import NavAccordionHeader from '../NavAccordionHeader';
import React, { useState } from 'react';

const NavAccordion = ({ children, menuActive }: any) => {
  const [active, setActive] = useState(false);

  const hanleClick = () => {
    setActive(!active);
  };

  return (
    <li className="nav-item">
      {React.cloneElement(children[0], { active, onClick: hanleClick })}
      {menuActive && active && React.cloneElement(children[1], { submenu: true })}
    </li>
  );
};

export default Object.assign(NavAccordion, {
  Header: NavAccordionHeader
});
